import React from 'react';
import i18next from 'i18next';
import { translate } from 'react-i18next';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { get } from 'lodash';

import TaxReceiptButton_en from './locales/TaxReceiptButton_en.json';
import TaxReceiptButton_fr from './locales/TaxReceiptButton_fr.json';

class TaxReceiptButton extends React.Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'TaxReceiptButton', TaxReceiptButton_en);
    i18next.addResourceBundle('fr', 'TaxReceiptButton', TaxReceiptButton_fr);
  }

  viewTaxReceipt = (transaction) => {
    if (get(transaction, 'plugins.taxReceipt[0]', null))
      this.props.downloadTaxReceipt(
        null,
        get(transaction, 'id', null),
        get(transaction, 'plugins.taxReceipt[0].id', null),
        get(transaction, 'plugins.taxReceipt[0].receiptNumber', null),
        this.props.t
      );
  };

  render() {
    const { transaction } = this.props;

    return (
      <Button
        shape="circle"
        onClick={() => this.viewTaxReceipt(transaction)}
      >
        <FontAwesomeIcon icon={["fal", "receipt"]} size="lg" />
      </Button>
    );
  }

}

export default translate('TaxReceiptButton')(TaxReceiptButton);
